module.exports = __webpack_public_path__ + "img/award-a-design-2022-bronze@2x.4154d054.png";